export default [
    {
        label: 'Api Keys',
        description: 'Generate additional API keys or delete them if needed.',
        route: {name: 'api-keys'},
        icon: 'api-key',
    },
    {
        label: 'Blacklists',
        description: 'Add bad IP addresses, BINs, credit cards, and more to your blacklists to permanently bar fraudsters from buying from you.',
        route: {name: 'blacklists'},
        icon: 'blacklists',
    },
    {
        label: 'Data Exports',
        description: 'Export your data once or on a recurring schedule and download the result as a CSV file.',
        route: {name: 'data-exports'},
        icon: 'data-exports',
    },
    {
        label: 'Integrations',
        description: 'Connect Rebilly to other apps within your workflow.',
        route: {name: 'integrations'},
        icon: 'integrations',
    },
    {
        label: 'Notifications',
        description: 'Notify your customers or your team as events happen, like a dispute or new customer creation.',
        route: {name: 'notifications'},
        icon: 'email',
    },
    {
        label: 'Rules Engine',
        description: 'Manage system and custom events to dynamically handle your business logic and automate actions.',
        route: {name: 'rules-engine'},
        icon: 'rules',
    },
    {
        label: 'Webhooks',
        description: 'Notify your systems when certain events happen in near real-time.',
        route: {name: 'webhooks'},
        icon: 'webhooks',
    },
];
